import React from 'react';

const Process = () => {
  return (
    <section className="sec process" id="process">
      <div className="wrap">
        <div className="rev">
          <div className="ey">Our Process</div>
          <h2>How we work with<br/><i>every client</i></h2>
        </div>
        <div className="process-steps">
          <div className="ps rev">
            <span className="ps-num">{"// "}01</span>
            <span className="ps-icon">🔍</span>
            <div className="ps-name">Discover</div>
            <p className="ps-text">Deep understanding of your domain, users, business model and goals. No assumptions. No templates.</p>
          </div>
          <div className="ps rev d1">
            <span className="ps-num">{"// "}02</span>
            <span className="ps-icon">🗺️</span>
            <div className="ps-name">Strategise</div>
            <p className="ps-text">Design the right AI solution — architecture, roadmap and success metrics agreed before a line of code is written.</p>
          </div>
          <div className="ps rev d2">
            <span className="ps-num">{"// "}03</span>
            <span className="ps-icon">⚡</span>
            <div className="ps-name">Build</div>
            <p className="ps-text">Rapid, iterative development using modern AI tools that compress timelines without compromising quality or security.</p>
          </div>
          <div className="ps rev d3">
            <span className="ps-num">{"// "}04</span>
            <span className="ps-icon">📈</span>
            <div className="ps-name">Scale</div>
            <p className="ps-text">Launch, measure, optimise and grow. We stay involved until real outcomes match the original ambition.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
